import { getDate } from './getDate';

export const compareDates = (date1?: Date | string, date2?: Date | string) => {
  if (!date1 || !date2) return 0;

  const parsedDate1 = getDate(date1);
  if (!parsedDate1) return 0;

  const parsedDate2 = getDate(date2);
  if (!parsedDate2) return 0;

  const t1 = parsedDate1.getTime();
  const t2 = parsedDate2.getTime();

  if (t1 > t2) return 1;
  if (t1 < t2) return -1;
  return 0;
};
